import { convertArrayToCamelCase, convertToCamelCase } from '@skytech/utils'

import type {
  SalaryDeductionApplication,
  SalaryDeductionApplicationExtended,
} from '@/modules/applications/salary-deduction/types'
import { get, post } from '@/util/auth'

const salaryDeductionApplicationResources = {
  get: async (applicationId: number) => {
    const application = await get<Record<string, unknown>>(
      `manager/salary-deduction-applications/${applicationId}`
    )
    const parsedApplication = convertToCamelCase(application) as Omit<
      SalaryDeductionApplicationExtended,
      'whiteLabelId'
    > & { whitelabelId?: number }
    const mappedKeyApplication = {
      ...parsedApplication,
      whiteLabelId: parsedApplication.whitelabelId,
    }
    delete mappedKeyApplication.whitelabelId

    return mappedKeyApplication as SalaryDeductionApplicationExtended
  },
  getList: async () => {
    const applications = await get<Record<string, unknown>[]>(
      'manager/salary-deduction-applications'
    )
    const parsedApplications = convertArrayToCamelCase(applications)

    return parsedApplications as SalaryDeductionApplication[]
  },

  // Mutations
  setStatus: ({ applicationId, statusId }: { applicationId: number; statusId: number }) =>
    post(`manager/salary-deduction-applications/${applicationId}/status`, {
      status: statusId,
    }),
}

export default salaryDeductionApplicationResources
